import { MapController } from 'react-map-gl'

export default class MyMapControls extends MapController {
  handleEvent(event) {
    const { type } = event
    const { className } = event.target
    const { swipeable } = event.target.dataset
    const { scrollable } = event.target.dataset
    const isInteractive = swipeable || /Image/.test(className)
    // console.log(className, isInteractive)
    if ((isInteractive && type !== 'wheel') || (scrollable && type === 'wheel'))
      return false
    return super.handleEvent(event)
  }
}
